import { z } from 'zod'
import { StoreSocialMediaKind, type StoreSocialMedia } from '../../models/AppSetting'

export const StoreSocialMediaDTOSchema = z.object({
  type: z.nativeEnum(StoreSocialMediaKind),
  url: z.string()
})

export type StoreSocialMediaDTO = z.infer<typeof StoreSocialMediaDTOSchema>

export function mapDTOToStoreSocialMedia (dto: StoreSocialMediaDTO): StoreSocialMedia {
  return {
    kind: dto.type,
    url: dto.url
  }
}

export function mapStoreSocialMediaToDTO (model: StoreSocialMedia): StoreSocialMediaDTO {
  return {
    type: model.kind,
    url: model.url
  }
}
